
import fileUploadService from '~/services/fileUpload';

export default {
    props: {
        /**
         * Should we allow video uploads?
         */
        enableVideos: {
            type: Boolean,
            default: false,
        },
        /**
         * A file object
         */
        field: {
            type: Object,
            default() {
                return {};
            },
        },
        /**
         * Enable instant upload
         */
        instantUpload: {
            type: Boolean,
            default: false,
        },
        /**
         * String to use for field label
         */
        label: {
            type: String,
            default() {
                return this.$t('common.add_images');
            },
        },
        /**
         * Is the user logged in
         */
        loggedIn: {
            type: Boolean,
            default: true,
        },
        /**
         * Singular image upload
         */
        single: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fieldLabel: this.label,
            files: this.value || [],
            showTooManyFilesError: false,
        };
    },
    computed: {
        supportedFormats() {
            let formats = '.png,.jpg,.jpeg,.heic';
            if (this.enableVideos) {
                formats += ',.ogg,.webm,.wmv,.mp4,.mov';
            }
            return formats;
        },
    },
    created() {
        if (this.enableVideos && this.label === this.$t('common.add_images')) {
            this.fieldLabel = this.$t('common.add_images_or_videos');
        }
    },
    methods: {
        emitFileList() {
            /**
             * Update V-model
             * @type {Array}
             */
            this.$emit(
                'input',
                this.files.filter((file) => !file.hasError),
            );
        },
        fileAdded(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            files = Array.from(files);
            if (this.files.filter((checkFile) => !checkFile.hasError).length + files.length > this.$config.maxNumFiles) {
                this.showTooManyFilesError = true;
                files = files.slice(0, this.$config.maxNumFiles - this.files.length);
            }
            files.forEach((file) => {
                const fileObject = {
                    progress: 0,
                    promise: null,
                    hasError: false,
                    isFinished: false,
                    data: file,
                };
                this.files.push(fileObject);
                if (this.instantUpload) {
                    this.startUpload(fileObject);
                    fileObject.promise.then(() => {
                        if (fileObject.hasError) {
                            if (this.files.filter((checkFile) => !checkFile.hasError).length <= this.$config.maxNumFiles) {
                                this.showTooManyFilesError = false;
                            }
                        }
                    });
                }
            });
            this.emitFileList();
        },
        reset() {
            this.files = [];
        },
        removeFile(removedFile) {
            this.files = this.files.filter((file) => file !== removedFile);
            this.emitFileList();
            this.showTooManyFilesError = false;
        },
        startUpload(file) {
            file.promise = fileUploadService([file], this.$axios, this.$config, this.$sentry, true, true);
        },
    },
};
